import { useEffect, useRef,useState} from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../auth";
import funzione_collegamento from "../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../funzioni/differenza_ore";
import "../stili/tabelle.css";
import "../stili/popup.css";
import "../stili/tabs.css"
import "../stili/analisi.css"
import "../stili/agenda.css"
import convertDate from "../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../funzioni/nome_id.js"
import {convertiIdInventario,convertiValuta,convertiColore,convertiTaglia,convertiTipoAccessori,convertiIdEscursione,convertiTipoStorage,convertiIdNoleggio,ordinaPerData,prendiNomePacchetto,coloreDaId,guadagnoEscursione,pacchettiAperti,materialeDisponibile,istruttori_disponibili,isoToString,calcolaStipendioFisso,convertiCambi} from "../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck,faDollarSign,faX,faStore, faPencil, faTrashCan,faCircleInfo,faSpinner,faChartSimple } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../assets/loading.json";
import status_lezione from "../funzioni/status_lezione"
/* global $ */
function AccessoriTab({maglietteDati,numeroConto}) {
let editMode=null
async function modificaStatus(datiPrima) {

    const contenuto =document.createElement("div")
    contenuto.style.padding = "0px";
    contenuto.innerText = `Sei sicuro di volere riportare l'accessorio in magazzino?`
    contenuto.style.marginTop = "10px";
    contenuto.style.fontWeight = "bold";
    contenuto.style.fontSize = "20px";
    contenuto.style.fontFamily = "Poppins, sans-serif";
    $("#modificaMagazzino").dxPopup("instance").option( "title",`Conferma ritorno in magazzino`);
    $("#modificaMagazzino").dxPopup("instance").option("contentTemplate", () => contenuto);
    $("#modificaMagazzino").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () { $("#modificaMagazzino").dxPopup("instance").hide();
        const dati_n={"accessorysold":0,"accessorysoldprice":null,"accessorysoldcustomer":null,"accessorysoldadvance":null,"accessorysolddate":null,"accessorysoldcurrency":null,}
        var richiesta=await funzione_collegamento({
                    userid: getUserId(),
                    token: getToken(),
                    valori:dati_n,
                    setId:datiPrima,
                    azione:'setAccessoryItem'})

        if (richiesta){
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"billid":numeroConto},
                        azione: "getAccessoryItems",
                    })
        let formattedRowsVendute=[]
        for (let maglia of magliette){
                formattedRowsVendute.push({"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        }
        },
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#modificaMagazzino").dxPopup("instance").hide();}
      },
    }],)
    $("#modificaMagazzino").dxPopup("instance").show();
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaMaglie() {
    useEffect(()=>{
        const fetchDati= async () => {
            $("#loadingOverlay").show()
            const allineamento="center"
        let formattedRowsVendute=[]
        for (let maglia of maglietteDati){
                formattedRowsVendute.push({"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
        }
    $("#gridContainerVendute").dxDataGrid({
            dataSource:formattedRowsVendute,
            columns:[
            {dataField:"tipo",alignment:"center",caption:"Tipo Accessorio",hidingPriority:1,
            customizeText:function (e){return convertiTipoAccessori(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valtipo").length===0) {
                $('<div id="vendute_valtipo"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":"Maglietta"},{"id":2,"name":"Cappello"},{"id":3,"name":"Laccio per Occhiali"}]
            $("#vendute_valtipo").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},
            {dataField:"taglia",alignment:"center",hidingPriority:2,caption:"Taglia Accessorio",customizeText:function (e){return convertiTaglia(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valtaglia").length===0) {
                $('<div id="vendute_valtaglia"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":"S"},{"id":2,"name":"M"},{"id":3,"name":"L"},{"id":4,"name":"XL"}]
            $("#vendute_valtaglia").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},
            {dataField:"colore",alignment:"center",hidingPriority:4,caption:"Colore Accessorio",customizeText:function (e){return convertiColore(e.value)},
            editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valcolore").length===0) {
                $('<div id="vendute_valcolore"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":"Rossa"},{"id":2,"name":"Gialla"},{"id":3,"name":"Blu"},{"id":4,"name":"Rosa"},{"id":5,"name":"Bianca"},{"id":6,"name":"Verde"},]
            $("#vendute_valcolore").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})}},
            {
            dataField: "dataVendita",
            hidingPriority:3,
            sortOrder: "desc",
            customizeText:function (e){
                return DateTime.fromISO(e.value).toFormat("dd/MM/yyyy")
            },
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#vendute_valreg").length===0) {
                $('<div id="vendute_valreg"></div>').appendTo(cellElement)
            }
            $("#vendute_valreg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          }},
          {dataField:"cliente",alignment:"center",hidingPriority:7},
            {dataField:"prezzoVendita",alignment:"center",
            hidingPriority:5,
            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valprezzo").length===0) {
                $('<div id="vendute_valprezzo"></div>').appendTo(cellElement)
            }
            $("#vendute_valprezzo").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"venduta",visible:false},
            {dataField:"pagato",alignment:"center",hidingPriority:6,

            cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value}{convertiValuta(cellInfo.data.valuta)}
                </div>
            );
          }},
            editCellTemplate:function(cellElement,cellInfo){
                if ($("#vendute_valpagato").length===0) {
                $('<div id="vendute_valpagato"></div>').appendTo(cellElement)
            }
            $("#vendute_valpagato").dxNumberBox({showSpinButtons: true,step:10,min:0,value:cellInfo.value,format:`#0.##'${convertiValuta(cellInfo.data.valuta)}'`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)}
            })}},
            {dataField:"valuta",

            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#vendute_valvaluta").length===0) {
                $('<div id="vendute_valvaluta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#vendute_valvaluta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#vendute_valprezzo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            $("#vendute_valpagato").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          }},

            {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => {
                      cellInfo.component.editRow(cellInfo.rowIndex)}}
                    />
                  );
                },
              },
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faStore}
                      color="#007bff"
                      onClick={() => modificaStatus(cellInfo.data.accessoryid)}
                    />
                  );
                },
              },

            ],
          },
            ],
         onRowPrepared: function (e) {
            setTimeout(() => {
                $("#loadingOverlay").hide();},500)

        },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainer").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
          if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const anticipo = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.prezzoVendita);

            if (isNaN(anticipo) ||( !isNaN(costo) && Math.abs(anticipo - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              $(e.rowElement).css("background-color", "#ffe6e6")
            }
          }
        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
          let dataTipo = [];
          for (let i = 1; i <= 2; i++) {
            dataTipo.push({ ID: i, nome: convertiTipoAccessori(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
          else if (e.parentType === "filterRow" && e.dataField === "taglia"){
          let dataTipo = [];
          for (let i = 1; i <= 4; i++) {
            dataTipo.push({ ID: i, nome: convertiTaglia(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            }
          }
          else if (e.parentType === "filterRow" && e.dataField === "colore"){
          let dataTipo = [];
          for (let i = 1; i <= 6; i++) {
            dataTipo.push({ ID: i, nome: convertiColore(i) });
          }
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'nome',searchEnabled: true, showClearButton:true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);
              }
            };
          }
        },
    onRowUpdated: async function (e) {
    const gridElement = $("#gridContainerVendute"); // Ottieni l'intera griglia

        // Aggiungi la classe di animazione alla griglia
        gridElement.addClass("table-updated");

        // Rimuovi la classe dopo l'animazione
        setTimeout(() => {
            gridElement.removeClass("table-updated");
        }, 1000);
    const dati_n={'accessorysolddate':convertDate(DateTime.fromISO(e.data.dataVendita)),'accessorysoldprice':e.data.prezzoVendita,'accessorysoldcurrency':e.data.valuta,'accessorysoldadvance':e.data.pagato,'accessorysoldcustomer':e.data.cliente,'accessorysold':e.data.venduta, };
    const richiesta = await funzione_collegamento({
       userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        setId:e.data.accessoryid,
        valori:dati_n,
        azione:'setAccessoryItem'})
        if (richiesta) {
            const magliette=await funzione_collegamento({
                        userid: getUserId(),
                        token: getToken(),
                        filtri:{"billid":numeroConto},
                        azione: "getAccessoryItems",
                    })
        formattedRowsVendute=[]
        for (let maglia of magliette){
                formattedRowsVendute.push({"tipo":maglia.accessorytype,"taglia":maglia.accessorysize,"colore":maglia.accessorycolor,"venduta":maglia.accessorysold,"accessoryid":maglia.accessoryid,"prezzo":maglia.accessoryprice,"prezzoVendita":maglia.accessorysoldprice,"pagato":maglia.accessorysoldadvance,"dataVendita":convertDate(maglia.accessorysolddate).toISO({ includeOffset: false }),"valuta":maglia.accessorysoldcurrency,"cliente":maglia.accessorysoldcustomer})
        }
        $("#gridContainerVendute").dxDataGrid("instance").option("dataSource",formattedRowsVendute)
        const message = `Accessorio modificato con successo`;

  window.DevExpress.ui.notify({message,
        position: {
          my: 'center',
          at: 'center',
          of: '#gridContainerVendute',
        },}, "success", 1000);
        }
    },
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "auto",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: false,
          allowDeleting: false,
          useIcons: true,
          popup: {
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            showTitle:true,
            },
            form: {
      colCount: 1,
            items: [
              {
                itemType: "group",
                colCount: 2,
                items: [
                { dataField: "dataVendita", label: { text: "Data di vendita" } },{ dataField: "cliente", label: { text: "Cliente" }},{ dataField: "prezzoVendita", label: { text: "Prezzo di Vendita" }},{ dataField: "pagato", label: { text: "Prezzo pagato" }},{ dataField: "valuta", label: { text: "Valuta vendita" }},
                ],
              },

            ],
          },
    },
        })
        $("#modificaMagazzino").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    });
        }
    fetchDati()
    },[])
    return <div id="gridContainerVendute"></div>
}
return <div>
            <TabellaMaglie/>
            <div id="loadingOverlay">
              <div className="spinner">
                <Lottie  style={{ width: "250px", height: "250px" }} animationData={animLoading} loop={true} />
              </div>
            </div>
        </div>
}
export default AccessoriTab